import { APP_ROUTES } from 'shared/constants/navigation';

export const PEARL_VENDOR_SIGNUP_LOADER_COLOR = '#2a8478';

export const isPearlVendorSignupFlowPath = (pathname) => {
    if (!pathname || typeof pathname !== 'string') return false;

    if (pathname.startsWith(APP_ROUTES.vendor.webstore.newsetup)) return true;
    if (pathname === APP_ROUTES.vendorNew) return true;
    if (pathname === APP_ROUTES.vendorLogin) return true;
    if (pathname === APP_ROUTES.vendor.ensureVendor) return true;

    const authPaths = [
        APP_ROUTES.vendor.auth.signup,
        APP_ROUTES.vendor.auth.welcome,
        APP_ROUTES.vendor.auth.login,
    ];
    return authPaths.includes(pathname);
};
